import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker'; // Import the date picker component
import "react-datepicker/dist/react-datepicker.css";

const SellItemModal = ({ item, onClose, onConfirmSale }) => {
    const [finalSellingPrice, setFinalSellingPrice] = useState('');
    const [finalProfit, setFinalProfit] = useState(0);
    // ADDED: State for the sale date, defaults to today
    const [saleDate, setSaleDate] = useState(new Date());
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (item) {
            setFinalSellingPrice(item.sellingPriceMYR || '');
        }
    }, [item]);

    useEffect(() => {
        const cost = item?.perUnitCostMYR || 0;
        const price = parseFloat(finalSellingPrice) || 0;
        setFinalProfit(price - cost);
    }, [finalSellingPrice, item]);

    if (!item) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        const price = parseFloat(finalSellingPrice);
        if (isNaN(price) || price <= 0) {
            setError('Please enter a valid final selling price.');
            return;
        }
        setError('');
        setIsSubmitting(true);
        // Pass the final data, including the saleDate, up to the parent
        await onConfirmSale(item, price, finalProfit, saleDate);
        setIsSubmitting(false);
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h3>Record Sale for: {item.childId}</h3>
                <p>Enter the final selling price and date for this item.</p>
                <form onSubmit={handleSubmit} className="investment-form">
                    <div className="form-field">
                        <label>Item Cost (RM)</label>
                        <input type="text" value={item.perUnitCostMYR.toFixed(2)} readOnly />
                    </div>
                    <div className="form-field">
                        <label>Final Selling Price (RM)</label>
                        <input
                            type="number"
                            step="0.01"
                            value={finalSellingPrice}
                            onChange={(e) => setFinalSellingPrice(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>
                    {/* ADDED: New Date Picker field for the sale date */}
                    <div className="form-field">
                        <label>Date Sold</label>
                        <DatePicker
                            selected={saleDate}
                            onChange={(date) => setSaleDate(date)}
                            dateFormat="dd/MM/yyyy"
                            className="date-picker-input"
                            required
                        />
                    </div>
                    <div className="form-field summary-box">
                        <label>Final Profit (RM)</label>
                        <h4 style={{ color: finalProfit < 0 ? 'var(--brand-danger)' : 'var(--brand-success)' }}>
                            {finalProfit.toFixed(2)}
                        </h4>
                    </div>
                    {error && <p className="error-message" style={{color: 'var(--brand-danger)'}}>{error}</p>}
                    <div className="form-actions" style={{ justifyContent: 'flex-end', marginTop: '1.5rem' }}>
                        <button type="button" className="cancel-button" onClick={onClose} disabled={isSubmitting}>Cancel</button>
                        <button type="submit" className="submit-button" disabled={isSubmitting}>
                            {isSubmitting ? 'Recording...' : 'Confirm Sale'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SellItemModal;